import { API_Data_DCB_Response, DCBData, DCBPayload } from "@/interfaces/api/dcb/dcb_types"
import { API_Error, API_Response } from "@/interfaces/api/response/api_response_types"
import { fetcher } from "@/utils/helpers"

export async function getDCBURL ({ payload }: { payload: DCBPayload }): Promise<API_Data_DCB_Response> {
  const res = await fetcher(`/api/dcb`, { 
    method: 'POST',
    cache: "no-store",
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  const response = await res.json() as API_Response<API_Data_DCB_Response>
  if (!res.ok) throw { code: res.status, description: 'Unknown DCB error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'DCB data missing in response' } as API_Error

  return response.data
}